import { render, staticRenderFns } from "./ShowAllOrders.vue?vue&type=template&id=4cfd8586&scoped=true"
import script from "./ShowAllOrders.vue?vue&type=script&lang=js"
export * from "./ShowAllOrders.vue?vue&type=script&lang=js"
import style0 from "./ShowAllOrders.vue?vue&type=style&index=0&id=4cfd8586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfd8586",
  null
  
)

export default component.exports